<div class="d-flex row no-gutters" [ngClass]="{'justify-content-end': !leftAligned}">
    <div class="col-xs-12 col-md-6 col-lg-4">
        <mat-form-field class="app-datepicker" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
            <input
                    matInput
                    #datepickerInput
                    readonly
                    autocomplete="off"
                    [matDatepicker]="datepicker"
                    [placeholder]="control.placeholder"
                    [min]="asFormsControl().minDate"
                    [max]="asFormsControl().maxDate"
                    (click)="openDatepicker(datepicker)"
                    (dateChange)="changeValue($event)"
            >
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>

            <mat-datepicker
                #datepicker
                [disabled]="control.disabled"
                (opened)="onTouched && onTouched()"
            ></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="pl-md-3 pl-0 align-self-end pb-3">
        <app-slide-toggle
                [checked]="control.disabled"
                [texts]="getTexts()"
                (change)="onSlideToggleChange($event)"
        ></app-slide-toggle>
    </div>
    <div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger w-100">
        <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
    </div>
</div>
